import type {
  GetDomainsManagementRegistrarsData,
  GetDomainsManagementRegistrarsResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getDomainRegistrarsApiModule(affiliatesApi: AxiosInstance) {
  return {
    /**
     * Get all available domain registrars
     *
     * @returns {Promise<Object>} api response
     */
    getDomainRegistrarProviders() {
      return affiliatesApi.get<GetDomainsManagementRegistrarsResponse>('/domains-management/registrars');
    },
  }
}
